import React from 'react';

const PaginationControls = ({ currentPage, totalPages, onPageChange, rowsPerPage, onRowsPerPageChange }) => {
    const maxVisiblePages = 3;
    let pages = [];

    // Calculate the first and last visible pages
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust the start page if there are fewer than maxVisiblePages at the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    // Add first page and previous ellipsis if needed
    if (adjustedStartPage > 1) {
        pages.push(1);
        if (adjustedStartPage > 2) {
            pages.push('...');
        }
    }

    // Add the visible page numbers
    for (let i = adjustedStartPage; i <= endPage; i++) {
        pages.push(i);
    }

    // Add next ellipsis and last page if needed
    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            pages.push('...');
        }
        pages.push(totalPages);
    }

    return (
        // fix to bottom of page
        <div className="fixed bottom-0 left-0 w-full flex justify-between bg-white p-4 shadow-md">
            {/* Left-aligned pagination controls */}
            <div className="flex space-x-2">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed"
                >
                    🠈
                </button>
                <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                    {pages.map((page, index) =>
                        page === '...' ? (
                            <span key={index} className="px-3 py-2 border border-gray-300 bg-white">
                                ...
                            </span>
                        ) : (
                            <button
                                key={index}
                                onClick={() => onPageChange(page)}
                                className={`px-3 py-2 border-x ${page === currentPage ? 'border-blue-500 bg-blue-500 text-white font-semibold' : 'border-gray-300 bg-white hover:bg-gray-100'}`}
                            >
                                {page}
                            </button>
                        )
                    )}
                </div>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed"
                >
                    🠊
                </button>
            </div>

            {/* Right-aligned rows per page dropdown */}
            <div className="flex items-center mr-4">
                <span className="mr-2">Rows per page:</span>
                <select
                    value={rowsPerPage}
                    onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                    className="px-2 py-1 border border-gray-300 rounded-lg bg-white"
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
        </div>
    );
};

export default PaginationControls;
